// @flow

import _ from 'lodash';
import React from 'react';

import { ButtonWrapper } from 'client/components/preRegistration/preRegistration';
import CountdownClock from 'client/components/preRegistration/countdownClock';
import { PRE_REG_WELCOME_BACK_CTA } from 'client/constants/amplitudeTracker';
import ROUTES from 'client/constants/routes';

import { Tracking } from 'web-core/src/tracking';

type Props = {
  continueBtn: string,
  continuePath: string,
  ctaBtn: string,
  ctaPath: string,
  firstName: string,
  header: string,
  isEmptyCart: boolean,
  oepStartDate: string,
  subheader: string,
  phase3: boolean,
  memberDashboard: boolean,
};

const WelcomeBack = (props: Props) => {
  const {
    continuePath,
    continueBtn,
    ctaPath,
    ctaBtn,
    firstName = '',
    header,
    isEmptyCart,
    oepStartDate,
    subheader,
    phase3,
    memberDashboard,
  } = props;
  const headerWithName = header.replace(':firstName', _.capitalize(firstName));
  const path = isEmptyCart
    ? ctaPath
    : phase3 && !memberDashboard
      ? ROUTES.PHASE3_DASHBOARD_ROUTE
      : continuePath;
  const btnText = isEmptyCart ? ctaBtn : continueBtn;

  const handleRedirect = () => {
    Tracking.track(PRE_REG_WELCOME_BACK_CTA, { path });
    window.location.href = path;
  };
  return (
    <React.Fragment>
      <h1 className="medium">{headerWithName}</h1>
      <h3>{subheader}</h3>
      <CountdownClock targetDate={oepStartDate} />
      <ButtonWrapper clickHandler={handleRedirect}>{btnText}</ButtonWrapper>
    </React.Fragment>
  );
};

export default WelcomeBack;
